import { render } from "./IFrameWall.vue?vue&type=template&id=483d2c94"
import script from "./IFrameWall.vue?vue&type=script&lang=js"
export * from "./IFrameWall.vue?vue&type=script&lang=js"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__